import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import { getName } from 'country-list';

import { createDeepEqualSelector } from '../../utils/selectors';

import { selectAuth } from '../selectors';

const selectBillingData = createDeepEqualSelector(selectAuth, (auth) => auth.billing);

const selectAddress = createDeepEqualSelector(selectBillingData, (billing) => get(billing, 'address', {}));

const selectCard = createDeepEqualSelector(selectBillingData, (billing) => get(billing, 'card', {}));

const selectSubscription = createDeepEqualSelector(selectBillingData, (billing) => get(billing, 'subscription', {}));

export const selectIsLoading = createDeepEqualSelector(selectBillingData, (billing) => get(billing, 'loading'));

export const selectError = createDeepEqualSelector(selectBillingData, (billing) => get(billing, 'err'));

export const selectErrorMessage = createDeepEqualSelector(selectBillingData, (billing) => get(billing, 'errMsg'));

export const selectAddressCity = createDeepEqualSelector(selectAddress, (address) => get(address, 'city'));

export const selectAddressCountry = createDeepEqualSelector(selectAddress, (address) => get(address, 'country'));

export const selectAddressCountryName = createDeepEqualSelector(selectAddressCountry, (country) => {
  if (isEmpty(country)) {
    return '';
  }

  return getName(country) || '';
});

export const selectAddressLine1 = createDeepEqualSelector(selectAddress, (address) => get(address, 'line1'));

export const selectAddressLine2 = createDeepEqualSelector(selectAddress, (address) => get(address, 'line2'));

export const selectAddressPostalCode = createDeepEqualSelector(selectAddress, (address) => get(address, 'postalCode'));

export const selectAddressState = createDeepEqualSelector(selectAddress, (address) => get(address, 'state'));

export const selectCardBrand = createDeepEqualSelector(selectCard, (card) => get(card, 'brand'));

export const selectCardFunding = createDeepEqualSelector(selectCard, (card) => get(card, 'funding'));

export const selectCardCountry = createDeepEqualSelector(selectCard, (card) => get(card, 'country'));

export const selectCardExpMonth = createDeepEqualSelector(selectCard, (card) => get(card, 'expMonth'));

export const selectCardExpYear = createDeepEqualSelector(selectCard, (card) => get(card, 'expYear'));

export const selectCardLastDigits = createDeepEqualSelector(selectCard, (card) => get(card, 'last4'));

export const selectSubscriptionBillingCycle = createDeepEqualSelector(selectSubscription, (subscription) =>
  get(subscription, 'billingCycle', ''),
);

export const selectSubscriptionPeriodEnd = createDeepEqualSelector(selectSubscription, (subscription) =>
  get(subscription, 'currentPeriodEnd', 0),
);

export const selectSubscriptionIsCanceled = createDeepEqualSelector(selectSubscription, (subscription) =>
  get(subscription, 'canceled', false),
);

export const selectCardExpiration = createDeepEqualSelector(
  [selectCardExpMonth, selectCardExpYear],
  (expMonth, expYear) => {
    const m = expMonth || '-';
    const y = expYear || '-';

    return `${m}/${y}`;
  },
);

export const selectCardNumber = createDeepEqualSelector(selectCardLastDigits, (lastDigits) => {
  if (isEmpty(lastDigits)) {
    return '-';
  }

  return `**** **** **** ${lastDigits}`;
});
